import { Locations } from 'EstraSuppliers'

export const useLocationFields = (
  locations: Locations,
  selectedProvinceId: string
) => {
  const provinceOptions = locations.map(province => ({
    value: province.id.toString(),
    label: province.name,
  }))

  const selectedProvince = [
    ...locations.filter(
      province => province.id.toString() === `${selectedProvinceId}`
    ),
  ][0]

  const cityOptions =
    selectedProvince && selectedProvince.cities
      ? selectedProvince.cities.map(city => ({
          value: city.id.toString(),
          label: city.name,
        }))
      : []

  return {
    provinceOptions,
    cityOptions,
  }
}
